<template>
	<p>
		By making a purchase, you agree to our
		<a
			:href="terms_and_conditions_link_prop"
			target="_blank"
			>Terms and Conditions</a
		>
		and your personal data will be protected in accordance with our
		<a
			:href="privacy_policy_link_prop"
			target="_blank"
			>Privacy Policy</a
		>.
	</p>
</template>
<style scoped></style>
<script>
	export default {
		props: {
			privacy_policy_link_prop: {
				type: String,
				required: true,
			},
			terms_and_conditions_link_prop: {
				type: String,
				required: true,
			},
		},
		data() {
			return {};
		},
		computed: {},
		methods: {},
	};
</script>
